import { object, string } from "yup";

export const profileUpdateSchema = object({
  first_name: string().required("Name is required"),
});
